export var SwapFailReasons;
(function (SwapFailReasons) {
    SwapFailReasons["RECEIVED_LESS_THAN_VALID_RANGE"] = "received_less_than_valid_range";
    SwapFailReasons["RECEIVED_MORE_THAN_VALID_RANGE"] = "received_more_than_valid_range";
})(SwapFailReasons || (SwapFailReasons = {}));
